export function toDate(value: unknown): Date | null {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value === 'object' && value !== null && 'toDate' in value) {
    const fn = (value as { toDate?: () => Date }).toDate;
    if (typeof fn === 'function') return fn.call(value);
  }
  if (typeof value === 'string' || typeof value === 'number') {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return null;
}

export function toMillis(value: unknown): number {
  return toDate(value)?.getTime() ?? 0;
}

export function formatDateTime(value: unknown): string {
  const d = toDate(value);
  if (!d) return '–';
  return d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
}
